import { render, staticRenderFns } from "./SithMesPrdPpHeaderInfoModifyOwnerList.vue?vue&type=template&id=3dd4169f&"
import script from "./SithMesPrdPpHeaderInfoModifyOwnerList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdPpHeaderInfoModifyOwnerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports